module.exports = __webpack_public_path__ + "static/media/service_system_8.d77275e1.png";